var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorldAltLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "world_alt_light"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 114",
    cx: 9.49984,
    cy: 9.49984,
    r: 6.33333,
    stroke: "#9DCB3B",
    strokeWidth: 0.791667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 115",
    d: "M14.7027 5.70504C14.1297 6.37571 13.3686 6.92599 12.4822 7.31043C11.5958 7.69486 10.6095 7.90242 9.60485 7.91596C8.6002 7.9295 7.606 7.74862 6.70438 7.38828C5.80277 7.02793 5.01961 6.49846 4.41962 5.8436",
    stroke: "#9DCB3B",
    strokeWidth: 0.791667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 116",
    d: "M14.7027 13.295C14.1297 12.6243 13.3686 12.074 12.4822 11.6896C11.5958 11.3051 10.6095 11.0976 9.60485 11.084C8.6002 11.0705 7.606 11.2514 6.70438 11.6117C5.80277 11.9721 5.01961 12.5015 4.41962 13.1564",
    stroke: "#9DCB3B",
    strokeWidth: 0.791667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 190",
    d: "M9.5 3.1665V15.8332",
    stroke: "#9DCB3B",
    strokeWidth: 0.791667
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldAltLight);
export default __webpack_public_path__ + "static/media/world_alt_light.93daf3893b99f8664e480e521b358d0f.svg";
export { ForwardRef as ReactComponent };